// BE Reference: https://bitbucket.org/adasiaholdings/anychat_chat_service/src/develop/domain/src/main/scala/anychat/chat_service/domain/SubErrorCode.scala last_checked_hash: 52c2021
export const AnyChatErrorCode = {
  //  Not Found (2001 - 2099)
  STORE_NOT_FOUND: 'STORE_NOT_FOUND', // 2005
  CUSTOMER_NOT_FOUND: 'CUSTOMER_NOT_FOUND', // 2006
  CHAT_NOT_FOUND: 'CHAT_NOT_FOUND', // 2007
  INFLUENCER_NOT_FOUND: 'INFLUENCER_NOT_FOUND', // 2030

  // Invalid Data (3000 - 3099)
  BAD_REQUEST: 'BAD_REQUEST', // 3000
  INVALID_EMAIL: 'INVALID_EMAIL', // 3001
  INVALID_URL: 'INVALID_URL', // 3002
  INVALID_REDIRECT_URL: 'INVALID_REDIRECT_URL', // 3003,
  INVALID_DATEFORMAT: 'INVALID_DATEFORMAT', // 3004,
  MISSING_PARAM_FOR_TYPE: 'MISSING_PARAM_FOR_TYPE', // 3005,
  MISSING_CRM_ACCOUNT_ID: 'MISSING_CRM_ACCOUNT_ID', // 3006,
  INVALID_AUTOMATION_TRIGGER: 'INVALID_AUTOMATION_TRIGGER', // 3007
  INVALID_FIELD: 'INVALID_FIELD', // 3008
  INVALID_AUTOMATION_CONTENT: 'INVALID_AUTOMATION_CONTENT', // 3009
  INVALID_BROADCAST_DATA: 'INVALID_BROADCAST_DATA', // 3010
  INVALID_BROADCAST_STATUS: 'INVALID_BROADCAST_STATUS', // 3011
  COUNT_ERROR: 'COUNT_ERROR', // 3012
  RICH_MENU_OVERLAP: 'RICH_MENU_OVERLAP', // 3013,
  INVALID_RICH_MENU_STATUS: 'INVALID_RICH_MENU_STATUS', // 3014,
  INVALID_RICH_MENU_DATA: 'INVALID_RICH_MENU_DATA', // 3015
  EMPTY_FIELD: 'EMPTY_FIELD', // 3016
  INVALID_TAG: 'INVALID_TAG', // 3017
  ALREADY_EXISTS: 'ALREADY_EXISTS', // 3018
  INCORRECT_ID_TOKEN: 'INCORRECT_ID_TOKEN', // 3019
  INVALID_RICH_MENU_ACTION_SIZE: 'INVALID_RICH_MENU_ACTION_SIZE', // 3020
  INPUT_FIELD_MISSING_NOT_MATCH_TYPE: 'INPUT_FIELD_MISSING_NOT_MATCH_TYPE', // 3021
  NOT_ALLOW_OPERATION_FOR_STATE: 'NOT_ALLOW_OPERATION_FOR_STATE', // 3022
  INVALID_TIME_RANGE: 'INVALID_TIME_RANGE', // 3023
  MISSING_PARAM_FOR_OPERATION: 'MISSING_PARAM_FOR_OPERATION', // 3024

  // Validation Fail (3101 - 3199)
  MERCHANT_SHOULD_HAVE_ACCOUNT_ID: 'MERCHANT_SHOULD_HAVE_ACCOUNT_ID', // 3101
  UNABLE_TO_DELETE_ACCOUNT_WITH_STORE: 'UNABLE_TO_DELETE_ACCOUNT_WITH_STORE', // 3102
  INVALID_RICH_MENU_FAIL_FROM_LINE: 'INVALID_RICH_MENU_FAIL_FROM_LINE', // 3103
  INVALID_RICH_MENU_FILESIZE_TOO_BIG: 'INVALID_RICH_MENU_FILESIZE_TOO_BIG', // 3104
  INVALID_RICH_MENU_WRONG_IMAGE_SIZE: 'INVALID_RICH_MENU_WRONG_IMAGE_SIZE', // 3105
  INVALID_RICH_MENU_IMAGE_NOT_MATCH_TEMPLATE: 'INVALID_RICH_MENU_IMAGE_NOT_MATCH_TEMPLATE', // 3106
  MESSENGER_BROADCAST_ZERO_RECIPIENT: 'MESSENGER_BROADCAST_ZERO_RECIPIENT', // 3110
  MESSENGER_BROADCAST_INVALID_OPERATION: 'MESSENGER_BROADCAST_INVALID_OPERATION', // 3111
  WHATSAPP_BROADCAST_REQUIRED_OPT_IN: 'WHATSAPP_BROADCAST_REQUIRED_OPT_IN', // 3124
  WHATSAPP_BROADCAST_CARDS_SAME_AMOUNT_BUTTONS_FAIL:
    'WHATSAPP_BROADCAST_CARDS_SAME_AMOUNT_BUTTONS_FAIL', // 3125
  INVALID_PHONE_NUMBER: 'INVALID_PHONE_NUMBER', // 3126
  NOT_INFLUENCER_MODE_ACCOUNT: 'NOT_INFLUENCER_MODE_ACCOUNT', // 3130
  CUSTOMER_ALREADY_LINKED_TO_INFLUENCER: 'CUSTOMER_ALREADY_LINKED_TO_INFLUENCER', // 3131
  INFLUENCER_ALREADY_LINKED_TO_OTHER_CUSTOMER: 'INFLUENCER_ALREADY_LINKED_TO_OTHER_CUSTOMER', // 3132
  INFLUENCER_MERGE_LINKED: 'INFLUENCER_MERGE_LINKED', // 3133
  INVALID_INFLUENCER_MERGE: 'INVALID_INFLUENCER_MERGE', // 3134

  // Not Support (3201 - 3299)
  MIME_TYPE_NOT_SUPPORT_FOR_IMAGE: 'MIME_TYPE_NOT_SUPPORT_FOR_IMAGE', // 3201
  MIME_TYPE_NOT_SUPPORT_FOR_VIDEO: 'MIME_TYPE_NOT_SUPPORT_FOR_VIDEO', // 3202
  MESSAGE_TYPE_NOT_ALLOW_VIDEO: 'MESSAGE_TYPE_NOT_ALLOW_VIDEO', // 3203
  NOT_SUPPORT_FILE_EXTENSION: 'NOT_SUPPORT_FILE_EXTENSION', // 3204
  NOT_SUPPORT_MESSAGE_TYPE: 'NOT_SUPPORT_MESSAGE_TYPE', // 3205
  MIME_TYPE_NOT_ALLOW: 'MIME_TYPE_NOT_ALLOW', // 3206
  UNRECOGNIZE_MIME_TYPE: 'UNRECOGNIZE_MIME_TYPE', // 3207
  UNEXPECTED: 'UNEXPECTED', // 3208
  NOT_ALLOW_TAG_SEARCH_WITH_NO_CRITERIA: 'NOT_ALLOW_TAG_SEARCH_WITH_NO_CRITERIA', // 3209

  // Problem with Data (3301 - 3399)
  REQUIRED_FIELD_IS_MISSING: 'REQUIRED_FIELD_IS_MISSING', //3309

  // External Service Exception (7000 - 7999)
  SHOPEE_REACH_5_MESSAGE_LIMIT: 'SHOPEE_REACH_5_MESSAGE_LIMIT', // 7015
  SHOPEE_USER_IS_FORBIDDEN: 'SHOPEE_USER_IS_FORBIDDEN', // 7016
} as const;

export type AnyChatErrorCode = (typeof AnyChatErrorCode)[keyof typeof AnyChatErrorCode];
